<template>
  <div
    v-loading="commonStore.systemConfigsLoading"
    element-loading-text="正在加载系统配置..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
    style="min-height: 100vh"
  >
    <router-view />
  </div>
</template>

<script setup>
import { useCommonStore } from './stores/common'
import { onMounted } from 'vue'
import { getUploadedFileUrl } from '@/utils/utils.js'

const commonStore = useCommonStore()

// Update the favicon with the system logo
const updateFavicon = iconUrl => {
  const link = document.querySelector("link[rel~='icon']")
  if (link) {
    link.href = iconUrl
  } else {
    const newLink = document.createElement('link')
    newLink.rel = 'icon'
    newLink.type = 'image/svg+xml'
    newLink.href = iconUrl
    document.head.appendChild(newLink)
  }
}

// 加载系统配置
onMounted(async () => {
  await commonStore.loadSystemConfigs()
  // 初始化 favicon
  if (commonStore.systemConfigs?.logo) {
    updateFavicon(getUploadedFileUrl(commonStore.systemConfigs.logo))
  }
  commonStore.loadLocalDeploymentTenant()
})
</script>
